import { LoginForm } from "../pages/login/LoginV2";
import { Signup } from "../pages/signup";
import { MultiStepLoanApplication } from "features/loanApplications/MultiStepForm";
import SalesHubDashboard from "features/salesHubDashboard/SalesHubDashboard";
import { Dashboard } from "../pages/dashboard";
import { LeadListPage } from "../pages/dashboard/LeadsPage";
import { LeadDetailsPage } from "../pages/dashboard/LeadDetailsPage";
import { CreateLeadPage } from "../pages/dashboard/CreateLead";
import CreateApplicationPage from "pages/dashboard/CreateApplicationPage";
import { ApplicationDetailsPage } from "pages/dashboard/ApplicationDetailsPage";
import { ApplicationsPage } from "pages/dashboard/ApplicationsPage";
import { UploadDocumentPage } from "pages/dashboard/UploadDocumentPage";
import { UserLoginHistoryPage } from "pages/dashboard/UserLoginHistoryPage";
import { TaskListPage } from "../pages/dashboard/TaskListPage";
import { CreateTaskPage } from "../features/tasks/components/CreateTaskPage";
import { TaskDetailsPage } from "../pages/dashboard/TaskDetailsPage";
import { SettingsPage } from "../pages/dashboard/SettingsPage";
import { ResidenceVerificationPage } from "../pages/dashboard/ResidenceVerificationPage";
import { ResidenceVerificationViewPage } from "../pages/dashboard/ResidenceVerificationViewPage";
import { GroupsListPage } from "../pages/dashboard/GroupsListPage";
import { GroupDetailsPage } from "../pages/dashboard/GroupDetailsPage";
import { CreateGroupPage } from "../pages/dashboard/CreateGroupPage";
import { AddMemberPage } from "../pages/dashboard/AddMemberPage";

export const routesConfig = [
  {
    path: "/",
    element: LoginForm,
    exact: true,
    protected: false,
  },
  {
    path: "/login",
    element: LoginForm,
    exact: true,
    protected: false,
  },
  {
    path: "/signup",
    element: Signup,
    exact: true,
    protected: false,
  },
  {
    path: "/settings",
    element: SettingsPage,
    exact: true,
    protected: true
  },
  {
    path: "/dashboard",
    element: Dashboard,
    exact: true,
    protected: true,
    children: [
      {
        path: "",
        element: SalesHubDashboard,
        exact: true,
        protected: true,
      },
      {
        path: "application/:leadId",
        element: CreateApplicationPage,
        exact: true,
        protected: true,
      },
      {
        path: "application/details/:applicationId",
        element: ApplicationDetailsPage,
        exact: true,
        protected: true,
      },
      {
        path: "application/uploadDocument/:applicationId",
        element: UploadDocumentPage,
        exact: true,
        protected: true,
      },
      {
        path: "applications",
        element: ApplicationsPage,
        exact: true,
        protected: true,
      },
      {
        path: "leads-list",
        element: LeadListPage,
        exact: true,
        protected: false,
      },
      {
        path: "lead-details/:id",
        element: LeadDetailsPage,
        exact: true,
        protected: true,
      },
      {
        path: "leads/create-lead",
        element: CreateLeadPage,
        exact: true,
        protected: true,
      },
      {
        path: "loan/create-application",
        element: MultiStepLoanApplication,
        exact: true,
        protected: true,
      },
      {
        path: "login-history",
        element: UserLoginHistoryPage,
        exact: true,
        protected: true,
      },
      {
        path: "tasks",
        element: TaskListPage,
        exact: true,
        protected: true
      },
      {
        path: "lead-details/:resourceId/create-task",
        element: CreateTaskPage,
        exact: true,
        protected: true
      },
      {
        path: "application/details/:resourceId/create-task",
        element: CreateTaskPage,
        exact: true,
        protected: true
      },
      {
        path: "lead-details/:resourceId/tasks/:taskId",
        element: TaskDetailsPage,
        exact: true,
        protected: true
      },
      {
        path: "application/details/:resourceId/tasks/:taskId",
        element: TaskDetailsPage,
        exact: true,
        protected: true
      },
      {
        path: "residence-verification/:applicationId",
        element: ResidenceVerificationPage,
        exact: true,
        protected: true
      },
      {
        path: "residence-verification/view/:applicationId",
        element: ResidenceVerificationViewPage,
        exact: true,
        protected: true
      },
      {
        path: "groups",
        element: GroupsListPage,
        exact: true,
        protected: true
      },
      {
        path: "groups/create",
        element: CreateGroupPage,
        exact: true,
        protected: true
      },
      {
        path: "groups/:id",
        element: GroupDetailsPage,
        exact: true,
        protected: true
      },
      {
        path: "groups/:id/add-member",
        element: AddMemberPage,
        exact: true,
        protected: true
      }
    ],
  },
];
